import React from 'react';

const ProjectCard = ({ title, context, description, stack, link, previewImage, previewAlt }) => {
    return (
        <article className="project-card">
            {previewImage && (
                <div className="project-preview">
                    <img src={previewImage} alt={previewAlt || `Capture du projet ${title}`} loading="lazy" />
                </div>
            )}
            <span className="project-context">{context}</span>
            <h2>{title}</h2>
            <p>{description}</p>
            <ul className="project-stack" aria-label={`Technologies utilisées pour ${title}`}>
                {stack.map((technology) => (
                    <li key={technology}>{technology}</li>
                ))}
            </ul>
            {link && (
                <a className="project-link" href={link} target="_blank" rel="noreferrer">
                    Voir le projet
                </a>
            )}
        </article>
    );
};

export default ProjectCard;
